<div class="expandable-content__container">
  <div class="content" [ngClass]="!isExpanded ? 'ellipsis collapse' : 'expand'">
    <ng-content></ng-content>
  </div>
  <button (click)="toggle()">
    <mat-icon *ngIf="!isExpanded">keyboard_arrow_down</mat-icon>
    <mat-icon *ngIf="isExpanded">keyboard_arrow_up</mat-icon>
  </button>
</div>
